<!-- eslint-disable -->
<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import ProgressBar from "/src/components/ProgressBar.vue";
import AnimatedNumber from "/src/components/AnimatedNumber.vue";
import StandardSection from "/src/components/StandardSection.vue";
import NumInput from "/src/components/helpers/NumInput.vue";
import clientConfig from '/src/config/client.js';
import { mapFields } from 'vuex-map-fields';
import { MDBBtn, MDBBtnClose } from 'mdb-vue-ui-kit';
import ToolTip from "../components/helpers/ToolTip.vue";

const ageAutoNumericOpts = {
  decimalPlaces: 0,
  wheelStep: 1,
};

export default {
  components: {
    ProgressBar,
    AnimatedNumber,
    NumInput,
    StandardSection,
    MDBBtn,
    ToolTip,
    MDBBtnClose
  },
  data() {
    return {
      readMoreAmountVisible: false,
      readMoreTargetVisible: false,

      clientConfig,

      projectedIncome: null,
      monthlyProjectedIncome: null,
      projectedIncomeDifference: null,
      runOutAge: null,
      lifeExpectancy: null,

      goToSupermodeller: false,
      acceptTerms: false,

      isHidden: true,
    };
  },
  computed: {
    ...mapState([
      'config',
    ]),
    ...mapFields([
      'engineObj.ageInput',
      'engineObj.sexInput',
      'engineObj.retirementAgeInput',
      'engineObj.salaryInput',
      'engineObj.superannuationBalanceInput',
      'engineObj.ageInput_2',
      'engineObj.retirementAgeInput_2',
      'engineObj.sexInput_2',
      'engineObj.salaryInput_2',
      'engineObj.superannuationBalanceInput_2',
      'engine.isCohabiting'
    ]),

    ...mapGetters([
      "debugMode",
      'targetIncome',
      'resultPerMonth',
      'standardChosen',
      'maxTargetIncome',
      'standards',
      'grossIncomeNeeded',
      'statePension',
    ]),
    ...mapMutations(['selectIsCohabiting']),

    currentAgeAutoNumericOpts: function () {
      return _.defaults({
        minimumValue: 0,
        maximumValue: this.config.inputs.age.max,
      }, ageAutoNumericOpts);
    },

    retirementAgeAutoNumericOpts: function () {
      return _.defaults({
        minimumValue: 0,
        maximumValue: this.config.inputs.retirementAge.max,
      }, ageAutoNumericOpts);
    },

    currentBalanceAutoNumericOpts: function () {
      return {
        currencySymbol: this.config.currencySymbol,
        minimumValue: '0',
        allowDecimalPadding: false,
        emptyInputBehavior: 'min',
        minimumValue: this.config.inputs.currentBalance.min,
        maximumValue: this.config.inputs.currentBalance.max,
      }
    },
    triangleBarLeftCSSValue() {
      const range = this.standards.comfortable.maxValue - this.standards.minimum.maxValue;
      const percentage = ((this.targetIncome - this.standards.minimum.maxValue) / range * 100);
      return percentage;
    },

    selectedStandard() {
      const selectedTargetIncome = Math.round(this.targetIncome / 100) * 100;
      const standardModerate = Math.round(this.config.headlineFigures.single.moderate / 100) * 100;
      const standardComfortable = Math.round(this.config.headlineFigures.single.comfortable / 100) * 100;
      const standardModerateCohabiting = Math.round(this.config.headlineFigures.cohabiting.moderate / 100) * 100;
      const standardComfortableCohabiting = Math.round(this.config.headlineFigures.cohabiting.comfortable / 100) * 100;
      if (this.isCohabiting) {
        if (selectedTargetIncome < standardModerateCohabiting) {
          return 'minimum'
        } else if (selectedTargetIncome >= standardModerateCohabiting && selectedTargetIncome < standardComfortableCohabiting) {
          return 'moderate'
        } else if (selectedTargetIncome >= standardComfortableCohabiting) {
          return 'comfortable'
        }
      } else {
        if (selectedTargetIncome < standardModerate) {
          return 'minimum'
        } else if (selectedTargetIncome >= standardModerate && selectedTargetIncome < standardComfortable) {
          return 'moderate'
        } else if (selectedTargetIncome >= standardComfortable) {
          return 'comfortable'
        }
      }
    }
  },
  watch: {
    ageInput(newVal) {
      if (!isNaN(newVal)) {
        this.retirementAgeInput = Math.max(67, newVal + 1);
      }
    },
    ageInput_2(newVal) {
      if (!isNaN(newVal)) {
        this.retirementAgeInput_2 = Math.max(67, newVal + 1);
      }
    },

  },
  methods: {
    toggleBool(bool) {
      if (this[bool]) {
        this[bool] = false;
        return
      }
      this[bool] = true;
    },
    reload() {
      window.location.reload();
    },
    handleReadMoreClick(key, ref) {
      this.toggleBool([key]);
      if (this[key]) {
        this.$nextTick(() => {
          this.$refs[ref].focus(); // for accessibility
        });
      }
    },

    goingToSupermodeller() {
      this.goToSupermodeller = true;
      if (this.debugMode) {
        console.log(this.goToSupermodeller)
      }
    },
    notGoingToSupermodeller() {
      this.goToSupermodeller = false
      if (this.debugMode) {
        console.log(this.goToSupermodeller)
      }
    },

    gotoCTA2() {
      window.open("https://www.ajg.com/au/", "_blank");
    },

    gotoCTA3() {
      window.open("https://www.ajg.com/au/", "_blank");
    },

    supermodellerLink() {
      let supermodellerLink = this.clientConfig.content.supermodellerLink;

      let supermodellerQuery =
        supermodellerLink +
        "?AgeNow=" + this.ageInput +
        "&AgeNow_2=" + this.ageInput_2 +
        "&Sex=" + this.sexInput +
        "&Sex_2=" + this.sexInput_2 +
        "&IncludePartner=" + this.isCohabiting +
        "&Salary=" + this.salaryInput +
        "&Salary_2=" + this.salaryInput_2 +
        "&SuperannuationBalance=" + this.superannuationBalanceInput +
        "&SuperannuationBalance_2=" + this.superannuationBalanceInput_2 +
        "&RetirementAge=" + this.retirementAgeInput +
        "&RetirementAge_2=" + this.retirementAgeInput_2 +
        "&DollarTargetIncome=" + (Math.round(this.targetIncome / 100)) * 100 +
        "&TermsAccepted=" + true;

      if (this.acceptTerms) {
        window.open(supermodellerQuery, "_blank");
        this.gtagEventCta1();
      } else {
        console.log("please accept terms")
        console.log(supermodellerQuery)
      }
    },

    gtagEventResults() {
      this.$gtag.event('custom_event', {
        'event_category': 'complete_journey',
      })
    },

    gtagEventCta1() {
      this.$gtag.event('custom_event', {
        'event_category': 'click_cta1',
        'event_label': this.clientConfig.content.gtag.clickCTA1Description,
      })
    },

    gtagEventCta2() {
      this.$gtag.event('custom_event', {
        'event_category': 'click_cta2',
        'event_label': this.clientConfig.content.gtag.clickCTA2Description,
      })
    },

    gtagEventCta3() {
      this.$gtag.event('custom_event', {
        'event_category': 'click_cta3',
        'event_label': this.clientConfig.content.gtag.clickCTA3Description,
      })
    },

  },
  mounted() {

    this.gtagEventResults();
  }
};
</script>

<template>
  <div class='result-page'>
    <div class='result-page_content_container'>
      <div class='result-page_top_content'>
        <div class="row">
          <div class="col-12 col-md-9 result-text" tabindex="0">
            <h3 class='result-page_top_content_header'>Your target retirement income</h3>
            <p class='result-page_top_content_main-para'>Based on your chosen lifestyle, we have estimated
              you'll need</p>

          </div>
          <div class="col-12 col-md-3">
            <div>
              <figure class="result-page_target_figure" tabindex="0">
                <AnimatedNumber :value='$filters.roundToNearestHundred(targetIncome)' :duration='0.5'
                  :prefix='config.currencySymbol' />
                <span>per year</span>
              </figure>
            </div>
          </div>
        </div>

      </div>

      <div class='target-bar'>
        <div class='target-triangle'
          :style="{ left: `${triangleBarLeftCSSValue}%`, transform: `translateX(-${triangleBarLeftCSSValue}%)` }"></div>
        <div class='target-circle'
          :style="{ left: `${triangleBarLeftCSSValue}%`, transform: `translateX(-${triangleBarLeftCSSValue}%)` }"></div>
      </div>


      <div class='result-page_standard-chosen'>
        <div class='standard-values d-block d-md-flex standard-values--minimum' tabindex="0">
          <span class='standard-values__text'>{{ standards.minimum.text }} </span>
          <br class="d-block d-md-none" />
          <span class='standard-values__figure'>{{ $filters.currency(config.headlineFigures[isCohabiting ? 'cohabiting'
            :
            'single'].minimum) }}</span>
        </div>
        <div class='standard-values d-block d-md-flex standard-values--moderate' tabindex="0">
          <span class='standard-values__text'>{{ standards.moderate.text }} </span>
          <br class="d-block d-md-none" />
          <span class='standard-values__figure'>{{ $filters.currency(config.headlineFigures[isCohabiting ? 'cohabiting'
            :
            'single'].moderate) }}</span>
        </div>
        <div class='standard-values standard-values--moderate' tabindex="-1">&nbsp;</div>
        <div class='standard-values standard-values--moderate' tabindex="-1">&nbsp;</div>
        <div class='standard-values standard-values--moderate' tabindex="-1">&nbsp;</div>
        <div class='standard-values standard-values--moderate' tabindex="-1">&nbsp;</div>
        <div class='standard-values standard-values--maximum' tabindex="0">
          <span class='standard-values__text d-block d-md-flex'>{{ standards.comfortable.text }} </span>
          <span class='standard-values__figure'>{{ $filters.currency(config.headlineFigures[isCohabiting ? 'cohabiting'
            :
            'single'].comfortable) }}</span>
        </div>
        <!-- <div class='standard-values standard-values--moderate' tabindex="0">&nbsp;</div>
        <div class='standard-values standard-values--moderate' tabindex="0">&nbsp;</div> -->
      </div>

      <div class='result-page_content categories'>
        <StandardSection v-if="selectedStandard == 'minimum'" :title="clientConfig.content.standards.minimum.heading"
          :titleHousehold="clientConfig.content.standards.minimum.headingHousehold"
          :descriptionHousehold="clientConfig.content.standards.minimum.descriptionHousehold"
          :titleTravel="clientConfig.content.standards.minimum.headingTravel"
          :descriptionTravel="clientConfig.content.standards.minimum.descriptionTravel"
          :titleFood="clientConfig.content.standards.minimum.headingFood"
          :descriptionFood="clientConfig.content.standards.minimum.descriptionFood"
          :titleClothes="clientConfig.content.standards.minimum.headingClothes"
          :descriptionClothes="clientConfig.content.standards.minimum.descriptionClothes">
          <span class="icon-info altPos ml-3" @click="isHidden = !isHidden"></span>

          <div class="helpText" v-html="clientConfig.content.results.helpText" v-if="!isHidden"></div>
        </StandardSection>

        <StandardSection v-if="selectedStandard == 'moderate'" :title="clientConfig.content.standards.modest.heading"
          :titleHousehold="clientConfig.content.standards.modest.headingHousehold"
          :descriptionHousehold="clientConfig.content.standards.modest.descriptionHousehold"
          :titleTravel="clientConfig.content.standards.modest.headingTravel"
          :descriptionTravel="clientConfig.content.standards.modest.descriptionTravel"
          :titleFood="clientConfig.content.standards.modest.headingFood"
          :descriptionFood="clientConfig.content.standards.modest.descriptionFood"
          :titleClothes="clientConfig.content.standards.modest.headingClothes"
          :descriptionClothes="clientConfig.content.standards.modest.descriptionClothes">
          <span class="icon-info altPos ml-3" @click="isHidden = !isHidden"></span>

          <div class="helpText" v-html="clientConfig.content.results.helpText" v-if="!isHidden"></div>
        </StandardSection>

        <StandardSection v-if="selectedStandard == 'comfortable'"
          :title="clientConfig.content.standards.comfortable.heading"
          :titleHousehold="clientConfig.content.standards.comfortable.headingHousehold"
          :descriptionHousehold="clientConfig.content.standards.comfortable.descriptionHousehold"
          :titleTravel="clientConfig.content.standards.comfortable.headingTravel"
          :descriptionTravel="clientConfig.content.standards.comfortable.descriptionTravel"
          :titleFood="clientConfig.content.standards.comfortable.headingFood"
          :descriptionFood="clientConfig.content.standards.comfortable.descriptionFood"
          :titleClothes="clientConfig.content.standards.comfortable.headingClothes"
          :descriptionClothes="clientConfig.content.standards.comfortable.descriptionClothes">
          <span class="icon-info altPos ml-3" @click="isHidden = !isHidden"></span>

          <div class="helpText" v-html="clientConfig.content.results.helpText" v-if="!isHidden"></div>
        </StandardSection>

      </div>


      <div class='result-page_content cta' :class="goToSupermodeller ? 'expanded' : ''">
        <MDBBtnClose @click="notGoingToSupermodeller()" v-if="goToSupermodeller" tabindex="0" />
        <div class='info-box' :class="goToSupermodeller ? 'expanded' : ''">
          <div class="info-wrapper calc" @click="goingToSupermodeller()" @keyup.enter="goingToSupermodeller()">
            <div class='info-icon'></div>
            <div class="info-description" tabindex="0" v-html="clientConfig.content.results.CTA1">
            </div>
          </div>

          <div class="supermodeller-actions-wrapper" :class="!isCohabiting ? 'notCohabiting' : ''"
            v-if="goToSupermodeller">

            <div class='result-page_columns row'>
              <div class="you" :class="isCohabiting ? 'cohabiting col-8 ' : 'notCohabiting'">
                <div class='result-page_inputs'>
                  <div class="pd-field" v-if="isCohabiting">
                    <div class="column-label you row">
                      <h5 tabindex="0">You</h5>
                    </div>
                  </div>
                  <div class="pd-field">
                    <label for='age' tabindex="0" :class="isCohabiting ? 'cohabiting' : ''">Age</label>
                    <NumInput v-model.number="ageInput" cssClass="input" :options="{
                      precision: 0,
                      currencyDisplay: 'hidden',
                      valueRange: { min: clientConfig.params.ageNow.min, max: clientConfig.params.ageNow.max }
                    }" name="age" placeholder="Age" :isRequired="true" requiredDescription="What is your age?"
                      requiredMessage="Please enter a value in this field." />
                  </div>

                  <div class="pd-field gender">
                    <label for='sex' tabindex="0" :class="isCohabiting ? 'cohabiting' : ''">Gender</label>
                    <div class="form-floating mb-3">
                      <select v-model="sexInput">
                        <option>Male</option>
                        <option selected>Female</option>
                      </select>
                    </div>

                  </div>

                  <div class="pd-field">
                    <label for='balance' tabindex="0" :class="isCohabiting ? 'cohabiting' : ''">Super balance</label>
                    <NumInput v-model.number="superannuationBalanceInput" cssClass="input" :options="{
                      precision: 0,
                      currencyDisplay: 'symbol',
                      valueRange: { min: clientConfig.params.superannuationBalance.min, max: clientConfig.params.superannuationBalance.max }
                    }" name="superannuationBalance" placeholder="Super Balance" :isRequired="true"
                      requiredDescription="What is your superannuation balance?"
                      requiredMessage="Please enter a value in this field." />
                  </div>

                  <div class="pd-field">
                    <label for='ret-age' tabindex="0" :class="isCohabiting ? 'cohabiting' : ''">Retirement age</label>
                    <NumInput v-model.number="retirementAgeInput" cssClass="input" :options="{
                      precision: 0,
                      currencyDisplay: 'hidden',
                      valueRange: { min: clientConfig.params.retirementAge.min, max: clientConfig.params.retirementAge.max }
                    }" name="retirementAge" placeholder="Retirement Age" :isRequired="true"
                      requiredDescription="What is your retirement age?"
                      requiredMessage="Please enter a value in this field." />
                  </div>

                  <div class="pd-field">
                    <label for='annual-salary' tabindex="0" :class="isCohabiting ? 'cohabiting' : ''">Income (before tax
                      and super)</label>
                    <NumInput v-model.number="salaryInput" cssClass="input" :options="{
                      precision: 0,
                      currencyDisplay: 'symbol',
                      valueRange: { min: clientConfig.params.salary.min, max: clientConfig.params.salary.max }
                    }" name="salary" placeholder="Salary" :isRequired="true" requiredDescription="What is your salary?"
                      requiredMessage="Please enter a value in this field." />
                  </div>
                </div>
              </div>

              <div class="your-partner" v-if="isCohabiting">
                <div class='result-page_inputs'>
                  <div class="pd-field">
                    <div class="column-label partner row">
                      <h5 tabindex="0">Your partner</h5>
                    </div>
                  </div>
                  <div class="pd-field">
                    <NumInput v-model.number="ageInput_2" cssClass="input" :options="{
                      precision: 0,
                      currencyDisplay: 'hidden',
                      valueRange: { min: clientConfig.params.ageNow.min, max: clientConfig.params.ageNow.max }
                    }" name="age" placeholder="Age" :isRequired="true" requiredDescription="What is your age?"
                      requiredMessage="Please enter a value in this field." />
                  </div>
                  <div class="pd-field">
                    <select v-model="sexInput_2" class="mb-3">
                      <option>Male</option>
                      <option selected>Female</option>
                    </select>
                  </div>
                  <div class="pd-field">
                    <NumInput v-model.number="superannuationBalanceInput_2" cssClass="input" :options="{
                      precision: 0,
                      currencyDisplay: 'symbol',
                      valueRange: { min: clientConfig.params.superannuationBalance.min, max: clientConfig.params.superannuationBalance.max }
                    }" name="superannuationBalance" placeholder="Super Balance" :isRequired="true"
                      requiredDescription="What is your partner superannuation balance?"
                      requiredMessage="Please enter a value in this field." />
                  </div>

                  <div class="pd-field">
                    <NumInput v-model.number="retirementAgeInput_2" cssClass="input" :options="{
                      precision: 0,
                      currencyDisplay: 'hidden',
                      valueRange: { min: clientConfig.params.retirementAge.min, max: clientConfig.params.retirementAge.max }
                    }" name="retirementAge" placeholder="Retirement Age" :isRequired="true"
                      requiredDescription="What is your partner retirement age?"
                      requiredMessage="Please enter a value in this field." />
                  </div>

                  <div class="pd-field">
                    <NumInput v-model.number="salaryInput_2" cssClass="input" :options="{
                      precision: 0,
                      currencyDisplay: 'symbol',
                      valueRange: { min: clientConfig.params.salary.min, max: clientConfig.params.salary.max }
                    }" name="salary" placeholder="Salary" :isRequired="true"
                      requiredDescription="What is your partner salary?"
                      requiredMessage="Please enter a value in this field." />
                  </div>
                </div>
              </div>
            </div>

            <div class="supermodeller-actions">
              <label class="acceptTerms">I have read and accepted the terms and conditions
                <input type="checkbox" v-model="acceptTerms">
                <span class="checkmark"></span>
              </label>
              <MDBBtn class="button" @click="supermodellerLink()">Try our {{
                clientConfig.content.results.supermodellerName }}</MDBBtn>

            </div>
          </div>
        </div>
        <div class='info-box cta-2' v-if="goToSupermodeller == false" @click="gtagEventCta2()">
          <div class='info-icon contact'></div>
          <div class="info-description" tabindex="0" v-html="clientConfig.content.results.CTA2">
          </div>
        </div>
        <div class='info-box cta3' v-if="goToSupermodeller == false" @click="gtagEventCta3()">
          <div class='info-icon asfa'></div>
          <div class="info-description" tabindex="0" v-html="clientConfig.content.results.CTA3">
          </div>
        </div>

        <div v-if="goToSupermodeller" class="hidden-boxes">
          <div class='info-box'>
            <div class='info-icon contact'></div>
            <div class="info-description" tabindex="0" v-html="clientConfig.content.results.CTA2">
            </div>
          </div>
          <div class='info-box'>
            <div class='info-icon asfa'></div>
            <div class="info-description" tabindex="0" v-html="clientConfig.content.results.CTA3">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>